import React from 'react'
import {calculatePurchasePrice} from '../../utils/calculator'
export function  ItemExtended(props){

  const option = props.option
  const name = option.name
  var stock = option.closing_stock
  if(typeof option.className !== "undefined" && option.className !== null) {
    return name
  }
  else {
    let suffix
    if (parseFloat(stock) <= 0) {
      suffix = "Out of stock"
    }
    else {
      const unit = option.unit
      if(typeof unit !== "undefined" && unit !== null) {

        if(typeof unit.container_unit !== "undefined" && unit.container_unit !== null && unit.container_unit.length > 0) {

          const containers = parseInt(parseFloat(stock)/parseFloat(unit.container_volume), 10)

          const remaining_primary_units = stock - (containers * unit.container_volume)

          suffix = containers +" " + unit.container_unit + " "+remaining_primary_units + " "+unit.primary_unit

        }
        else {
          suffix =  Number(stock)+" "+ unit.primary_unit
        }
      }
      else {
        suffix = Number(stock)
      }

    }


    let cpr = Number(option.closing_purchase_basic_rate)
    let cpr_with_tax
    if(option.gst && option.gst.igst) {
      const igst_pct = parseFloat(option.gst.igst)
      cpr_with_tax = calculatePurchasePrice(cpr, igst_pct)
      cpr_with_tax = <span>({cpr_with_tax})</span>
    }

    let brandName = option.brand ? option.brand.name : ""

    return (<div>{name + "-" + suffix}
          <div className={props.requireBrand ? "": "hidden"}>
              {brandName}
          </div>
        <div className={props.requireRates ? "": "hidden"}>
          Closing Rate: {Number(option.closing_purchase_basic_rate) } {cpr_with_tax}
        </div>
    </div>)
  }
}



export function updateHistory(props, object) {
  let state = props.location.state || {}
  props.history.push(props.location.pathname, Object.assign(state, object))
}



// WEBPACK FOOTER //
// ./src/components/commons/functions.js